import { createContext } from 'react'
import type { AuthUser } from '@/lib/tokenManager'
import type { PermissionCode, Role } from './permissions'

export type AuthContextValue = {
  user: AuthUser | null
  isAuthenticated: boolean
  isPlatformAdmin: boolean
  isImpersonating: boolean
  hasPermission(code: PermissionCode | string): boolean
  hasRole(...roles: Role[]): boolean
  refresh(): Promise<boolean>
  logout(): Promise<void>
}

// Lives in its own file so AuthProvider.tsx can be a pure component
// module - react-refresh requires components-only files for fast HMR.
export const AuthContext = createContext<AuthContextValue | null>(null)
